export const messages_en = {
  "header.home": "Home",
  "header.about": "About Us",
  "header.services": "Services",
  "header.contacts": "Contacts",
  "header.login": "Login",
  "header.language": "Language",
  "footer.legalNotes": "Legal Notes",
  "footer.privacyPolicy": "Privacy Policy",
  "footer.cookiePolicy": "Cookie Policy",

  // ROUTE /login
  "login.title": "REVENGE",
  "login.subtitle":
    "ECU FILE SERVICE IN A FLASH",
  "login.paragraph":
    " ",
  "login.button.contact": "Contact Us",
  "login.form.title": "Login",
  "login.form.username": "Username",
  "login.form.email": "Email",
  "login.form.password": "Password",
  "login.form.rememberMe": "Remember Me",
  "login.form.submit": "Login",
  "login.form.forgotPassword": "Forgot your password?",
  "login.form.or": "Or",
  "login.form.requestAccess": "Request Access",
  "login.form.warnings.field":
    "The username or password you entered is incorrect, please try again",
  "login.form.warnings.empty": "Required field",
  "login.form.warnings.email": "Invalid email",
  "login.proceed": "Now you can proceed to login",

  // request access form
  "register.title": "Request Access from Administrator",
  "register.form.firstname": "First Name",
  "register.form.lastname": "Last Name",
  "register.form.email": "Email",
  "register.form.company": "Company Name",
  "register.form.address": "Address",
  "register.form.city": "City",
  "register.form.zip": "Postal Code",
  "register.form.country": "Country",
  "register.form.vat": "VAT or Tax ID",
  "register.form.phone": "Phone",
  "register.form.isSlave": "I am a Slave",
  "register.form.submit": "Submit",
  "register.form.warnings.field": "Invalid value",
  "register.form.warnings.empty": "Required field",
  "register.form.warnings.number.type": "Enter a numeric value",
  "register.form.error":
    "Error loading the form. Please recheck the entered data and try again.",
  "register.form.success": "Request sent successfully!",
  "register.form.success.message":
    "You will receive an email with the instructions to complete the registration process.",

  // FORGOT PASSWORD
  "password.requirements":
    "The new password must contain at least 8 characters, including at least one uppercase letter, one lowercase letter, one number, and one special character from @, $, !, %, *, ?, &",
  "password.minimum": "The password must be at least 8 characters long",
  "password.match": "Passwords do not match",
  "password.error.reset": "Error resetting your password, please try again.",
  "forgotPassword.title":
    "Enter your email address to receive password recovery instructions.",
  "forgotPassword.requestAccess": "Not registered yet? Request access",
  "forgotPassword.error": "The entered email is incorrect, please try again.",
  "forgotPassword.success": "Check your inbox. Thank you!",

  // ROUTE /contacts
  "contacts.title": "Contact Us",
  "contacts.subtitle":
    "If you have any questions or concerns, you can leave a message here. We will get back to you as soon as possible.",
  "contacts.form.firstname": "First Name",
  "contacts.form.lastname": "Last Name",
  "contacts.form.email": "Email",
  "contacts.form.message": "Your Message",
  "contacts.form.disclaimer": "By clicking Submit, you agree to our",
  "contacts.form.privacy": "Privacy Policy",
  "contacts.form.cookie": "Cookie Policy",
  "contacts.form.end": "and",
  "contacts.form.submit": "Submit",
  "contacts.form.submitted": "Submitted!",
  "contacts.form.success": "Thank you for contacting us, see you soon!",
  "contacts.form.warnings.email": "Enter a valid email address",
  "contacts.form.warnings.empty": "Required field",
  "contacts.form.warnings.max": "Enter up to 50 characters",
  "contacts.form.warnings.min": "Enter at least 2 characters",

  // General items
   "dashboard.header.credits": "Total remaining credits",
  "dashboard.header.buyCredits": "Buy credits",
  "dashboard.review.projects": "My Projects",
  "dashboard.review.tickets": "My Tickets",
  "dashboard.review.tickets.open": "Open",
  "dashboard.review.tickets.closed": "Closed",
  "dashboard.review.tickets.inProgress": "In Progress",
  "dashboard.review.tickets.completed": "Completed",
  "dashboard.review.addProjectTitle": "Add a New Project",
  "dashboard.review.addProjectSubtitle":
    "Click here to start recording a new project on the vehicle. You will be guided through the steps to define the details and specifications of the modification or work to be done.",
  "dashboard.review.project.new": "New",
  "dashboard.review.project.inProgress": "In Progress",
  "dashboard.review.project.pending": "Pending",
  "dashboard.review.project.failed": "Failed",
  "dashboard.review.project.refunded": "Refunded",
  "dashboard.review.project.completed": "Completed",
  "dashboard.sidebar.dashboard": "Dashboard",
  "dashboard.sidebar.users": "Users",
  "dashboard.sidebar.tickets": "Tickets",
  "dashboard.sidebar.operations": "Projects",
  "dashboard.sidebar.profile": "Profile",
  "dashboard.sidebar.settings": "Settings",
  "dashboard.sidebar.support": "Support",
  "dashboard.sidebar.logout": "Logout",
  "dashboard.internalSidebar.welcome": "Welcome",
  "dashboard.internalSidebar.help": "Need help?",
  "dashboard.internalSidebar.guide": "Download our guide",
  "dashboard.totalUsers": "Total Users",
  "dashboard.totalNewProjects": "New Projects",
  "dashboard.totalOpenTickets": "Open Tickets",
  "dashboard.recentUsers": "Recent Users",
  "dashboard.recentUsers.subtitle": "Latest Registered Users",
  "dashboard.recentTickets": "Recent Tickets",
  "dashboard.recentTickets.subtitle": "Latest Submitted Tickets",
  "dashboard.completedProjects": "Completed Projects",
  "dashboard.completedProjects.current": "Current Year",
  "dashboard.completedProjects.previous": "Previous Year",

  // TABLES
  "table.noData": "No data available",
  "table.header.status": "Status",
  "table.header.created": "Created",
  "table.header.updated": "Updated",
  "table.header.type": "Vehicle",
  "table.header.brand": "Brand",
  "table.header.model": "Model",
  "table.header.category": "Category",
  "table.header.companyName": "Company Name",
  "table.header.details": "Details",
  "table.header.title": "Title",
  "table.header.firstName": "First Name",
  "table.header.lastName": "Last Name",
  "table.header.email": "Email",
  "table.header.phone": "Phone",
  "table.header.actions": "Azioni",
  "table.header.sent": "Sent by",

  // STATUS
  "status.open": "Open",
  "status.closed": "Closed",
  "status.pending": "Pending",
  "status.completed": "Completed",
  "status.inProgress": "In Progress",
  "status.refunded": "Refunded",
  "status.failed": "Failed",
  "status.new": "New",
  "status.active": "Active",
  "status.banned": "Banned",

  // BUTTONS

  "button.back": "Back",
  "button.confirm": "Confirm",
  "button.create": "Create",
  "button.save": "Save",
  "button.details": "Details",
  "button.createTicket": "Create Ticket",
  "button.startChat": "Start Chat",
  "button.send": "Send",
  "button.newProject": "New Project",
  "button.filter": "Filter",
  "button.filter.manual": "Filter by manually inserted projects",
  "button.contactUs": "Contact Us",
  "button.backHome": "Back to Home",
  "button.reply": "Reply",
  "button.insert.vehicleInfo": "Enter vehicle information manually",
  "button.modifyOrder": "Modify Order",
  "button.search": "Search...",
  "button.addCreditTier": "Add Credit Tier",
  "button.remove": "Remove",
  "button.viewAll": "View All",
  "button.cancel": "Cancel",
  "button.add": "Add",
  "button.show": "Show more",
  "button.hide": "Hide",
  "button.delete": "Delete",
  "button.update": "Update",
  "button.close": "Close",

  // USERS
  "users.title": "User Management",
  "users.subtitle": "View and manage all registered users",
  "users.projects.title": "Projects",
  "users.userData": "View user data",
  "users.updateStatus": "Update the user's status",
  "users.update": "Update the projects' list",
  "users.singleUser": "User",
  "users.temporaryPassword": "Temporary password",
  "users.temporaryPassword.sent": "Password sent on",
  "users.status": "Status",
  "users.addCredits.title": "Add Credits to User",
  "users.addCredits.reason": "Choose a reason",
  "users.reason.notSpecified": "Not specified",
  "users.reason.welcome": "Welcome bonus",
  "users.reason.refund": "Refund",

  // PROJECT
  "project.title.plural": "Projects",
  "project.title.singular": "Project",
  "project.created": "Created on",
  "project.updated": "Updated on",
  "project.type": "Vehicle Type",
  "project.status": "Status",
  "project.brand": "Brand",
  "project.model": "Model",
  "project.generation": "Generation",
  "project.gearbox": "Gearbox",
  "project.year": "Year",
  "project.engine": "Engine",
  "project.fuel": "Fuel",
  "project.engineHp": "Engine Hp",
  "project.readingMethod": "Reading Method",
  "project.ecuBrand": "ECU Brand",
  "project.ecuName": "ECU Name",
  "project.ecuType": "ECU Type",
  "project.services": "Services (Extra Options)",
  "project.dtc": "Excluded DTCs",
  "project.dtc.achronym": "DTC (Diagnostic Trouble Codes)",
  "project.file": "Attached File",
  "project.modFile": "Processed MOD File",
  "project.noModFile": "No MOD file present.",
  "project.tickets": "Related Tickets",
  "project.noTickets": "No tickets related to this project.",
  "project.new": "New Project",
  "project.select.type": "Select Vehicle Type",
  "project.select.brand": "Select Brand",
  "project.select.model": "Select Model",
  "project.select.generation": "Select Generation",
  "project.select.engine": "Select Engine",
  "project.select.engineHp": "Select Engine Power",
  "project.select.year": "Select Year",
  "project.select.gearbox": "Select Gearbox",
  "project.select.fuel": "Select Fuel",
  "project.select.ecuBrand": "Select ECU Brand",
  "project.select.ecuName": "Select ECU Name",
  "project.select.ecuType": "Select ECU Type",
  "project.select.readingMethod": "Select Reading Method",
  "project.select.notFound":
    "I couldn’t find information about my vehicle in the menus",
  "project.insert.vehicleInfo": "Enter Vehicle Information Manually",
  "project.total.services": "Total Services",
  "project.total": "Total",
  "project.service": "Service",
  "project.price": "Price",
  "project.dtc.select": "Type the DTC code you wish to deactivate",
  "project.new.modal": "You selected services for a total of",
  "project.new.modal.services": "You selected these services for your project:",
  "project.new.modal.missing.start": "You need",
  "project.new.modal.missing.end": "to complete the project",
  "project.modal.continue": "To continue, modify your choice or",
  "project.modal.buy": "click here to buy further credits",
  "project.modal.credits": "will be charged",
  "project.updateStatus": "Update the project status",

  // CREDITI
  credit: "credit",
  credits: "credits",
  "credits.title": "Buy Credits",
  "credits.prices": "Prices",
  "credits.tiers": "Available Credit Tiers",
  "credits.unitPrice": "Unit Price",
  "credits.bar": "Slide the bar to select the desired number of credits",
  "credits.selected": "Selected Credits",
  "credits.total": "Total",
  "credits.specialPrice": "Special Price",

  //ORDER
  "order.new": "New Order",
  "order.vat": "of which VAT",
  "order.total": "Total",
  "order.success": "Thank you! Your order has been successfully processed.",
  "order.confirm": "You will receive a confirmation email shortly.",
  "order.error": "An error occurred during payment.",
  "order.error.paypal": "The payment was not processed.",

  // TICKET
  "ticket.help": "Create a new ticket starting from a project",
  "ticket.title.singular": "Ticket",
  "ticket.title.plural": "Tickets",
  "ticket.status": "Status",
  "ticket.category": "Category",
  "ticket.created": "Created on",
  "ticket.sent": "Sent by",
  "ticket.attachment": "Attachment",
  "ticket.resolutionDate": "Estimated Resolution Date",
  "ticket.noResolutionDate": "No resolution date indicated.",
  "ticket.communications": "Communications",
  "ticket.type": "Type a message...",
  "ticket.noMessages": "No messages present.",
  "ticket.new.title": "New Ticket",
  "ticket.new.project": "Related Project",
  "ticket.new.name": "Ticket Title",
  "ticket.new.category": "Ticket Category",
  "ticket.new.description": "Ticket Description",
  "ticket.new.description.max": "Maximum 500 characters",
  "ticket.new.attachment": "Attachment",

  // FILE
  "file.attach": "Click here or drag and drop a file to attach it",
  "file.attach.admin": "Click here to attach the processed file",
  "file.attach.user": "Click here to attach the file to be processed *",
  "file.formats": "Accepted formats:",
  "file.noFile": "No file uploaded",
  "file.size.error": "The file size exceeds the maximum allowed, Maximum 10 MB",
  "file.toBeProcessed": "File attached by the user to be processed",

  //TOOLTIP
  "tooltip.downloadFile": "Click to download the file",
  "tooltip.uploadFile":
    "Click to upload a file in .zip, .mod, or .bin format, Max 10 MB",
  "tooltip.viewTicket": "Click to view the ticket",
  "tooltip.temporaryPassword":
    "The temporary password will be sent to the user, who must change it upon first login.",

  // PROFILE
  "profile.tab1": "Edit Profile",
  "profile.tab2": "Security",
  "profile.createNewPassword": "Create a new password",
  "profile.confirmNewPassword": "Confirm the new password",

  // FAQ

  "faq.title": "Frequently Asked Questions (FAQ)",
  "faq.new": "New FAQ",
  "faq.question": "Question",
  "faq.answer": "Answer",
  "faq.noFaqs": "No FAQs available.",
  "faq.create": "Create a new question",
  "faq.delete": "Are you sure you want to delete the question",
  "faq.edit": "Edit question",

  "settings.title": "Settings",
  "settings.listing.credits": "Credit price listing",
  "settings.listing.credits.min": "Min. tier",
  "settings.listing.credits.max": "Max. tier",
  "settings.listing.credits.price": "Unit price",
  "settings.listing.credits.special": "It is a special price",
  "settings.listing.services": "Service price listing",
  "settings.listing.services.service": "Service",
  "settings.listing.services.price": "Price in credits",

  // SNACKBAR
  "snackbar.correctValueStep":
    "Correct one or more value among the max thresholds",
  "snackbar.unitPrice": "Unit price missing",
  "snackbar.validStep": "Enter a valid step within the Credits Listing section",
  "snackbar.file.format":
    "The file format is not supported, please upload a .zip, .mod, or .bin file",
  "snackbar.project.success": "Project successfully updated",
  "snackbar.project.error": "Error updating the project, please try again.",
  "snackbar.copied": "Copied to clipboard",
  "snackbar.form": "Fill in all fields marked with * (asterisk)",
  "snackbar.fields": "Fill in all fields please",
  "snackbar.manual.vehicleInfo":
    "Please fill the required fields: Brand and Model",

  // ALERT
  "alert.loadingError": "Error loading the data",
};
